module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Foreword"
    }
  }, [_vm._v("Foreword, by Jim Allison")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1"
    }
  }, [_vm._v("1. Amazon Rising")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Battle of the Sexes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Guards of Honor")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Girl Guard Trivia")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Tactical Differences")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Uniforms")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Biographies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Stitzer’s Other Guards")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Girl Cadets of Rawlins")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Girl Cadets of Laramie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC1"
  }, [_c('span', {
    attrs: {
      "href": "#/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0